import { configureStore } from '@reduxjs/toolkit';
import sidebarReducer from './sidebarSlice';
import authReducer from './authSlice';
import chatBotReducer, { chatBotPersistenceMiddleware } from './chatBotSlice';

export const store = configureStore({
  reducer: {
    sidebar: sidebarReducer,
    auth: authReducer,
    chatBot: chatBotReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['chatBot/initializeChatBot/fulfilled'],
        ignoredPaths: ['chatBot.messages.timestamp', 'chatBot.error.timestamp']
      }
    }).concat(chatBotPersistenceMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 